import React from 'react';

const inputCls =
  'w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-900 focus:border-emerald-500 focus:outline-none dark:border-slate-600 dark:bg-slate-800 dark:text-white';

function Field({ label, value, onChange, textarea, type = 'text', placeholder }) {
  return (
    <label className="block">
      <span className="mb-1 block text-xs font-medium text-slate-700 dark:text-slate-200">{label}</span>
      {textarea ? (
        <textarea rows={2} className={inputCls} value={value || ''} placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)} />
      ) : (
        <input type={type} className={inputCls} value={value || ''} placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)} />
      )}
    </label>
  );
}

// Delivery format + sender contact (saved to the account) + recipient details
// (saved on the message). All optional — blanks become [placeholders].
export function SendSetup({
  deliveryFormat, setDeliveryFormat,
  contact, setContact,
  recipient, setRecipient,
  onBack, onNext,
}) {
  const c = (k) => (v) => setContact({ ...contact, [k]: v });
  const r = (k) => (v) => setRecipient({ ...recipient, [k]: v });
  return (
    <div>
      <h2 className="mb-1 text-lg font-semibold text-slate-900 dark:text-white">How will you send this?</h2>
      <p className="mb-4 text-sm text-slate-600 dark:text-slate-300">
        Your details personalize the correspondence — fill in what you can.
      </p>

      <div className="mb-5 flex gap-3">
        {[['email', 'Email', 'Copy-and-paste into your mail app or tenant portal'],
          ['letter', 'Printed letter', 'A formal Word letter with full addresses']].map(([key, label, desc]) => (
          <label key={key}
            className={`flex-1 cursor-pointer rounded-xl border p-4 transition ${
              deliveryFormat === key
                ? 'border-emerald-500 bg-emerald-50 dark:bg-emerald-900/30'
                : 'border-slate-200 bg-white hover:border-emerald-300 dark:border-slate-700 dark:bg-slate-800'
            }`}>
            <input type="radio" name="delivery" value={key} className="sr-only"
              checked={deliveryFormat === key} onChange={() => setDeliveryFormat(key)} />
            <span className="block font-semibold text-slate-900 dark:text-white">{label}</span>
            <span className="mt-1 block text-xs text-slate-600 dark:text-slate-300">{desc}</span>
          </label>
        ))}
      </div>

      <h3 className="mb-2 text-sm font-bold text-slate-800 dark:text-slate-100">Your details</h3>
      <div className="grid gap-3 sm:grid-cols-2">
        <Field label="Your name" value={contact.name} onChange={c('name')} />
        <Field label="Property name" value={contact.property_name} onChange={c('property_name')} />
        <Field label="Unit" value={contact.unit} onChange={c('unit')} />
        <Field label="Phone" value={contact.phone} onChange={c('phone')} />
        {deliveryFormat === 'letter' ? (
          <Field label="Your mailing address" textarea value={contact.address} onChange={c('address')}
            placeholder={'123 Main St\nDenver, CO 80202'} />
        ) : (
          <Field label="Your email" type="email" value={contact.email} onChange={c('email')} />
        )}
      </div>

      <h3 className="mb-2 mt-5 text-sm font-bold text-slate-800 dark:text-slate-100">Who it&apos;s going to</h3>
      <div className="grid gap-3 sm:grid-cols-2">
        <Field label="Their name (property manager / landlord)" value={recipient.recipient_name} onChange={r('recipient_name')} />
        <Field label="Management company" value={recipient.recipient_company} onChange={r('recipient_company')} />
        {deliveryFormat === 'letter' ? (
          <Field label="Their mailing address" textarea value={recipient.recipient_address} onChange={r('recipient_address')} />
        ) : (
          <Field label="Their email" type="email" value={recipient.recipient_email} onChange={r('recipient_email')} />
        )}
      </div>

      <div className="mt-6 flex justify-between">
        <button type="button" onClick={onBack} className="rounded-lg px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-800">
          Back
        </button>
        <button type="button" onClick={onNext} className="rounded-lg bg-emerald-600 px-5 py-2 text-sm font-semibold text-white hover:bg-emerald-700">
          Next: choose a tone
        </button>
      </div>
    </div>
  );
}
